import { Injectable } from '@angular/core';

@Injectable()
export class KitchenService {
  constructor() {}

  getProjectTypeName(index: string) {

  }

  get_kitchen_scope_module_type(index: string) {
    // tslint:disable-next-line:prefer-const
    let array = ['Tibrokök', 'Vedum', 'Kungsäter kök', 'Arredo3', 'Arrital Cucine',
      'ARXI - Tecnocucina', 'Binova', 'Canadaköket', 'Claessonkök', 'Creoform Kök',
      'Electrolux Home', 'Epoq', 'Himle Kök', 'Härjedalskök', 'IKEA', 'Interhem',
      'Invita', 'Kitchn', 'Kvik', 'Köksfabriken', 'Marbodal', 'Mälarkök', 'Noblessa Kök',
      'Novaflex', 'Perfect Inredning', 'Siematic', 'Smedstorp', 'Strömsdal Kök & Interiör',
      'Unique Wood', 'Apparat Kök', 'Ballingslöv',
      'Bomanskök', 'Bulthaup', 'Geco', 'Hagaköket', 'HTH', 'Infra Kök', 'Kvänum Kök',
      'Köksskräddarn', 'Lidhults Kök', 'LIJO Kök', 'Lundins Kök', 'Länghems kök', 'Mobalpa',
      'Modexa', 'NordDesign', 'Poggenpohl', 'Puustelli', 'Scandinavian Kitchen', 'Storsjökök'];

    return array[Number(index)];
  }

  get_scope_price_offer(index: string) {
    // tslint:disable-next-line:prefer-const
    let array = [];
    return array[Number(index)];
  }

  get_scope_project_budget(index: string) {
    // tslint:disable-next-line:prefer-const
    let array = [];
    return array[Number(index)];
  }

  get_kitchen_scope_is_module(value: string) {
    if (value === 'True') {
      return 'Modul';
    } else {
      return 'Platsbyggd';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/seller/service/kitchen.service.ts